import type { RootState } from '..';
import { createStringContentSlice } from './helpers/slice_helpers';

const careerSummarySlice = createStringContentSlice({ name: 'careerSummary' });

export const { setContent: updateCareerSummary } = careerSummarySlice.actions;

export const selectCareerSummary = (state: RootState) => state.careerSummary.content;

export default careerSummarySlice.reducer;
